module.exports = __webpack_public_path__ + "img/微信图片_20240910174026.09612430.png";